export default [
    {
        displayName: "None",
        type: "none",
    },
    {
        displayName: "Default",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 100, //0.01-2000
        knee: 4,
        mix: 0.9,
    },
    {
        displayName: "Default - High Ratio",
        type: "compression",
        ratio: 16,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 100, //0.01-2000
        knee: 4,
        mix: 0.9,
    },
    {
        displayName: "High Ratio",
        type: "compression",
        ratio: 16,
        threshold: 0.0125, //18dB
        release: 1500, //0.01-9000
        attack: 100, //0.01-2000
        knee: 6,
        mix: 1,
    },
    {
        displayName: "Medium Ratio",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 100, //0.01-2000
        knee: 6,
        mix: 1,
    },
    {
        displayName: "Low Ratio",
        type: "compression",
        ratio: 8,
        threshold: 0.0125, //18dB
        release: 1500, //0.01-9000
        attack: 100, //0.01-2000
        knee: 4,
        mix: 1,
    },
    {
        displayName: "Medium Ratio - Fast Attack",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 50, //0.01-2000
        knee: 5,
        mix: 0.8,
    },
    {
        displayName: "Medium Ratio - Slow Attack",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 250, //0.01-2000
        knee: 5,
        mix: 0.8,
    },
    {
        displayName: "Medium Ratio - Slow Release",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 200, //0.01-2000
        knee: 4,
        mix: 0.8,
    },
    {
        displayName: "Custom",
        type: "compression",
        ratio: 12,
        threshold: 0.0125, //18dB
        release: 2000, //0.01-9000
        attack: 100, //0.01-2000
        knee: 5,
        mix: 1,
    },
    // Fixed Gain presets
    {
        displayName: "Fixed Gain -3dB",
        type: "fixedGain",
        gainReduction: 0.7, // -3dB in linear gain
        fadeTime: 200, // milliseconds for fade in/out
    },
    {
        displayName: "Fixed Gain -6dB",
        type: "fixedGain",
        gainReduction: 0.5, // -6dB in linear gain
        fadeTime: 200, // milliseconds for fade in/out
    },
    {
        displayName: "Fixed Gain -12dB",
        type: "fixedGain",
        gainReduction: 0.25, // -12dB in linear gain
        fadeTime: 200, // milliseconds for fade in/out
    },
    {
        displayName: "Fixed Gain -16dB",
        type: "fixedGain",
        gainReduction: 0.16, // -16dB in linear gain
        fadeTime: 200, // milliseconds for fade in/out
    },
];
